module.exports = __webpack_public_path__ + "img/10.bcefe423.jpg";